import { htmlDisable, htmlEnable, htmlIded } from '../fun-js-lib/html'
import { strIntersperse } from '../fun-js-lib/str'
import { checkContentFilledCorrectly, onInputInContent } from './content'
import { addHint, changeHint, emptyMechanizationHint, emptyRemarksHint, emptyWeatherHint, emptyWorkDescriptionHint, noShiftsFilledHint, noTemperaturesFilledHint, partlyFilledShiftHint, partlyFilledTemperatureHint, removeHint } from './hint'
import { isRemarksInputElementEmpty } from './remarks'
import { getShiftTimesEditableInputs } from './shiftTimes'
import { getTemperatureInputs } from './temperature'
import { getWeatherInputs } from './weather'
import { isWorkDescriptionInputElementEmpty } from './work-description'
import { getMechanizationTextarea, getWorkersEditableInputs } from './workers-and-mechanization'

export function initValidateSign () {
  initHint()
  onInputInContent(validate)
  validate()
}

function initHint () {
  addHint(signButton().parentElement, '', 'top')
}

function validate () {
  let hint = errorHint()
  if (hint === '') {
    enableLaunchSignPopup()
  } else {
    disableLaunchSignPopup(hint)
  }
}

function errorHint () {
  let parts = hintParts().filter(s => s !== '')
  return strIntersperse(parts, '<br>')
}

function hintParts () {
  if (isEditedBySupervisor()) {
    return [
      checkContentFilledCorrectly(),
      checkRemarksFilled()
    ]
  } else {
    return [
      checkContentFilledCorrectly(),
      checkAtLeastOneShiftFilled(),
      checkAtLeastOneTemperatureFilled(),
      checkWeatherFilled(),
      checkMechanizationFilled(),
      checkNoPartlyFilledShifts(),
      checkNoPartlyFilledTemperatures(),
      checkWorkDescriptionFilled()]
  }
}

export function isEditedBySupervisor () {
  return htmlIded('role').innerHTML === 'Supervisor'
}

function checkRemarksFilled () {
  return isRemarksInputElementEmpty() ? emptyRemarksHint : ''
}

function checkWorkDescriptionFilled () {
  return isWorkDescriptionInputElementEmpty() ? emptyWorkDescriptionHint : ''
}

function checkAtLeastOneShiftFilled () {
  return noRowsCompleted(shifts()) ?
    noShiftsFilledHint :
    ''
}

function checkAtLeastOneTemperatureFilled () {
  return noRowsCompleted(temperatures()) ?
    noTemperaturesFilledHint :
    ''
}

function checkWeatherFilled () {
  return isNotSet(getWeatherInputs()[0].value) ?
    emptyWeatherHint :
    ''
}

function checkMechanizationFilled () {
  return isNotSet(getMechanizationTextarea().value) ?
    emptyMechanizationHint :
    ''
}

function checkNoPartlyFilledShifts () {
  return hasIncompleteRow(shifts()) ?
    partlyFilledShiftHint :
    ''
}

function checkNoPartlyFilledTemperatures () {
  return hasIncompleteRow(temperatures()) ?
    partlyFilledTemperatureHint :
    ''
}

function shifts () {
  let shiftTimes = divideIntoGroupsOfN(2, getShiftTimesEditableInputs().map(({ value }) => value))
  let workers = divideIntoGroupsOfN(4, getWorkersEditableInputs().map(({ value }) => value))
  let rows = []
  for (let i = 0; i < 3; i++) {
    rows.push(shiftTimes[i].concat(workers[i]))
  }
  return rows
}

function temperatures () {
  return divideIntoGroupsOfN(
    2, getTemperatureInputs().map(({ value }) => value)
  )
}

function divideIntoGroupsOfN (n, items) {
  return new Array(Math.ceil(items.length / n))
    .fill()
    .map(() => items.splice(0, n))
}

function noRowsCompleted (rowCollection) {
  return rowCollection.map(
    row => areAllItemsSet(row)
  ).reduce((a, b) => a + b) == 0
}
function areAllItemsSet (items) {
  return items.map(item => {
    return isSet(item)
  }).reduce((a, b) => a * b)
}

function hasIncompleteRow (rowCollection) {
  return atLeastOneFalse(
    rowCollection.map(isEmptyOrComplete)
  )
}
function atLeastOneFalse (items) {
  return !areAllItemsTrue(items)
}
function isEmptyOrComplete (row) {
  return noneOrAllItemsTrue(row.map(isSet))
}
function noneOrAllItemsTrue (items) {
  return !(hasSomeItemsTrue(items) && hasSomeItemsFalse(items))
}
function hasSomeItemsTrue (items) {
  return items.reduce((a, b) => a + b) > 0
}
function areAllItemsTrue (items) {
  return items.reduce((a, b) => a * b)
}
function hasSomeItemsFalse (items) {
  return !areAllItemsTrue(items)
}

function isSet (item) {
  return item != null && item != ""
}
function isNotSet (item) {
  return !isSet(item)
}

function enableLaunchSignPopup () {
  removeHint(signButton().parentElement)
  htmlEnable(signButton())
}

/**
 * @param {string} hint 
 */
function disableLaunchSignPopup (hint) {
  htmlDisable(signButton())
  changeHint(signButton().parentElement, hint)
}

function signButton () {
  return document.getElementsByClassName('launch-sign-popup')[0]
}